import { __spreadArrays } from "tslib";
import { createSelector } from 'reselect';
import _map from 'lodash/map';
export function participantsByGroupIdSelector(presenceByParticipantId) {
    var result = {};
    _map(presenceByParticipantId, function (p, participantId) {
        if (p.online) {
            result[p.groupId] = __spreadArrays((result[p.groupId] || []), [participantId]);
        }
    });
    return result;
}
var presenceByParticipantIdSelector = function (state) { return state.presence.participantsById; };
export var presenceByGroupIdSelector = createSelector([presenceByParticipantIdSelector], participantsByGroupIdSelector);
